import { render, staticRenderFns } from "./ConfirmAccountClosureModal.vue?vue&type=template&id=bd8d9496&scoped=true&"
import script from "./ConfirmAccountClosureModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccountClosureModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAccountClosureModal.vue?vue&type=style&index=0&id=bd8d9496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8d9496",
  null
  
)

export default component.exports